import { all, put, select } from 'redux-saga/effects';
import { elmoSaysThisMightBeADeviationUrl } from '../../utils/deviations';
import { initBrowseStream, deselectAll, unsetCurrentFolderId, initGallectionDeviationStream, initSingleDeviationByLookupStream } from '../actions';
import { MediaSourceType } from '../types';
import { getCurrentMediaSource } from '../selectors';
export default function*({ payload: { query, allowSearchByUrl } }) {
    const mediaSource = yield select(getCurrentMediaSource);
    const actionsToPut = [
        deselectAll(),
        unsetCurrentFolderId()
    ];
    const possibleUrlLookup = elmoSaysThisMightBeADeviationUrl(query);
    if (allowSearchByUrl && possibleUrlLookup) {
        actionsToPut.push(initSingleDeviationByLookupStream(possibleUrlLookup));
    } else if (mediaSource === MediaSourceType.GALLERY || mediaSource === MediaSourceType.COLLECTION) {
        actionsToPut.push(initGallectionDeviationStream());
    } else if (mediaSource === MediaSourceType.BROWSE) {
        actionsToPut.push(initBrowseStream());
    }
    yield all(actionsToPut.map((actionToPut)=>put(actionToPut)));
}

//# sourceMappingURL=setSearchQuery.js.map